module.exports = __webpack_public_path__ + "img/pdf.3f43df44.svg";